<template>
    <div class="t_content_view">
        <div class="t_stat_box">
            <div class="t_stat">
                <div class="t_stat_k">收集码</div>
                <div class="t_stat_v">{{ stats.code_count }}</div>
            </div>
            <div class="t_stat">
                <div class="t_stat_k">累计提交</div>
                <div class="t_stat_v">{{ stats.submit_count }}<em>条</em></div>
            </div>
            <div class="t_stat">
                <div class="t_stat_k">已添加好友</div>
                <div class="t_stat_v">{{ stats.added_count }}<em>条</em></div>
            </div>
            <div class="t_stat t_stat--warn">
                <div class="t_stat_k">待添加</div>
                <div class="t_stat_v">{{ stats.pending_count }}<em>条</em></div>
            </div>
            <div class="t_stat t_stat--danger">
                <div class="t_stat_k">建码失败</div>
                <div class="t_stat_v">{{ stats.build_fail_count }}<em>条</em></div>
            </div>
        </div>

        <div class="t_search_box">
            <div class="t_search_select">
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="changeinput" size="small" v-model="searchdata.keyword" placeholder="请输入收集码名称" />
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">状态：</span>
                <el-select style="width: 140px;" size="small" v-model="searchdata.status" @change="statuschange" clearable placeholder="请选择">
                    <el-option label="启用" :value="1" />
                    <el-option label="停用" :value="0" />
                    <el-option label="已失效" value="expired" />
                </el-select>
            </div>
            <el-button @click="resetsearch" color="#F1F3F9" style="margin-bottom: 10px;" type="primary">重置</el-button>
        </div>

        <el-button color="#4F46E5" class="t_add_people" type="primary" @click="goCreate">新建收集码</el-button>

        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%">
            <el-table-column label="收集码名称" min-width="150">
                <template #default="scope">
                    <div>{{ scope.row.name }}</div>
                    <div class="t_sub">创建于 {{ scope.row.created_at }}</div>
                </template>
            </el-table-column>
            <el-table-column label="接待坐席" min-width="140">
                <template #default="scope">
                    <div>{{ (scope.row.seat_names || []).join('、') || '—' }}</div>
                    <div class="t_sub">共 {{ (scope.row.seat_names || []).length }} 位坐席</div>
                </template>
            </el-table-column>
            <el-table-column label="收集字段" min-width="140">
                <template #default="scope">
                    <span style="color: #606266;">{{ fieldText(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="预设标签" min-width="120">
                <template #default="scope">
                    <template v-if="scope.row.tag_names && scope.row.tag_names.length">
                        <el-tag v-for="(item, index) in scope.row.tag_names" :key="index" size="small"
                            style="margin: 2px 4px 2px 0;">
                            {{ item }}
                        </el-tag>
                    </template>
                    <span v-else>—</span>
                </template>
            </el-table-column>
            <el-table-column label="已收集" width="90">
                <template #default="scope">
                    <el-button size="small" type="text" style="color: #4F46E5; font-weight: 600;"
                        @click="openRecords(scope.row)">{{ scope.row.submit_count }}</el-button>
                </template>
            </el-table-column>
            <el-table-column label="有效期" width="90">
                <template #default="scope">
                    <span>{{ scope.row.valid_days }} 天</span>
                </template>
            </el-table-column>
            <el-table-column label="到期时间" min-width="150">
                <template #default="scope">
                    <div>{{ scope.row.expire_at || '—' }}</div>
                    <div class="t_sub">{{ expireText(scope.row) }}</div>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="90">
                <template #default="scope">
                    <el-tag v-if="scope.row.is_expired" size="small" type="info">已失效</el-tag>
                    <el-tag v-else-if="scope.row.status === 1" size="small" type="success">启用</el-tag>
                    <el-tag v-else size="small" type="info">停用</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="210">
                <template #default="scope">
                    <el-button size="small" type="text" style="color: #4F46E5"
                        @click="openLink(scope.row)">链接</el-button>
                    <el-button size="small" type="text" style="color: #4F46E5"
                        @click="goEdit(scope.row.id)">编辑</el-button>
                    <el-button v-if="!scope.row.is_expired" size="small" type="text" style="color: #4F46E5"
                        @click="toggleStatus(scope.row)">{{ scope.row.status === 1 ? '停用' : '启用' }}</el-button>
                    <el-button size="small" type="text" style="color: #4F46E5"
                        @click="delbtn(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />

        <!-- 投放链接 -->
        <el-dialog v-model="linkWindow" title="投放链接" width="520px">
            <div style="font-size: 15px; font-weight: 600;">{{ currentCode.name }}</div>
            <div style="color: #909399; font-size: 12px; margin: 4px 0 14px;">
                接待坐席：{{ (currentCode.seat_names || []).join('、') || '—' }}
                　·　到期时间：{{ currentCode.expire_at || '—' }}
            </div>
            <div class="t_link_box">
                <span>{{ h5Link }}</span>
                <el-button size="small" type="text" style="color: #4F46E5" @click="copy(h5Link)">复制</el-button>
            </div>
            <div style="color: #909399; font-size: 12px; margin-top: 10px;">
                投放该链接即可，客户在 H5 填写后添加所选坐席为好友。到期后链接自动失效，已收集数据不受影响。
            </div>
            <template #footer>
                <el-button @click="linkWindow = false">关闭</el-button>
                <el-button color="#4F46E5" type="primary" @click="openH5">打开填写页</el-button>
            </template>
        </el-dialog>

        <!-- 填写记录抽屉 -->
        <el-drawer v-model="recordWindow" :title="'填写记录 · ' + currentCode.name" size="920px">
            <div class="t_stat_box" style="margin-bottom: 16px;">
                <div class="t_stat">
                    <div class="t_stat_k">提交记录</div>
                    <div class="t_stat_v">{{ recordStats.submit_count }}<em>条</em></div>
                </div>
                <div class="t_stat">
                    <div class="t_stat_k">已添加好友</div>
                    <div class="t_stat_v">{{ recordStats.added_count }}<em>条</em></div>
                </div>
                <div class="t_stat t_stat--warn">
                    <div class="t_stat_k">待添加</div>
                    <div class="t_stat_v">{{ recordStats.pending_count }}<em>条</em></div>
                </div>
                <div class="t_stat t_stat--danger">
                    <div class="t_stat_k">建码失败</div>
                    <div class="t_stat_v">{{ recordStats.build_fail_count }}<em>条</em></div>
                </div>
            </div>

            <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="recordData.data" style="width: 100%">
                <el-table-column prop="created_at" label="填写时间" width="160" />
                <el-table-column label="客户" min-width="120">
                    <template #default="scope">
                        <div>{{ scope.row.name || '—' }}</div>
                        <div class="t_sub">坐席 {{ scope.row.seat_name }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号" width="130" />
                <el-table-column label="加好友状态" width="110">
                    <template #default="scope">
                        <el-tag size="small" :type="scope.row.add_status === 1 ? 'success' : 'warning'">
                            {{ scope.row.add_status_label }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="建码状态" min-width="170">
                    <template #default="scope">
                        <el-tag size="small" :type="scope.row.build_status === 1 ? 'success' : 'danger'">
                            {{ scope.row.build_status_label }}
                        </el-tag>
                        <div v-if="scope.row.build_status === 2 && scope.row.fail_reason" class="t_fail">
                            {{ scope.row.fail_reason }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template #default="scope">
                        <el-button size="small" type="text" style="color: #4F46E5"
                            @click="openRecordDetail(scope.row.id)">详情</el-button>
                        <el-button v-if="scope.row.build_status === 2 && scope.row.retryable" size="small" type="text"
                            style="color: #4F46E5" :loading="retryingId === scope.row.id"
                            @click="retry(scope.row.id)">重试</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagechange :total="recordTotal" :nowpage="recordQuery.page" @page_change="recordPageChange" />
        </el-drawer>

        <!-- 填写详情 -->
        <el-dialog v-model="detailWindow" title="填写详情" width="520px">
            <div style="font-size: 15px; font-weight: 600; margin-bottom: 12px;">{{ recordDetail.name || '—' }}</div>
            <div v-for="(item, index) in recordDetail.form_data" :key="index" class="t_detail_row">
                <span style="color: #909399;">{{ item.label }}</span>
                <span style="text-align: right;">{{ item.value || '—' }}</span>
            </div>
            <div class="t_detail_row">
                <span style="color: #909399;">接待坐席</span>
                <span>{{ recordDetail.seat_name || '—' }}</span>
            </div>
            <div class="t_detail_row">
                <span style="color: #909399;">填写时间</span>
                <span>{{ recordDetail.created_at }}</span>
            </div>
            <div class="t_detail_row">
                <span style="color: #909399;">加好友状态</span>
                <span>{{ recordDetail.add_status_label }}</span>
            </div>
            <div class="t_detail_row">
                <span style="color: #909399;">建码状态</span>
                <span :style="{ color: recordDetail.build_status === 2 ? '#F56C6C' : '' }">
                    {{ recordDetail.build_status_label }}
                </span>
            </div>
            <div v-if="recordDetail.build_status === 2 && recordDetail.fail_reason" class="t_detail_row">
                <span style="color: #909399;">失败原因</span>
                <span style="color: #F56C6C; text-align: right;">{{ recordDetail.fail_reason }}</span>
            </div>
            <div v-if="recordDetail.added_at" class="t_detail_row">
                <span style="color: #909399;">添加时间</span>
                <span>{{ recordDetail.added_at }}</span>
            </div>
            <template #footer>
                <el-button @click="detailWindow = false">关闭</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router'
import { newinfolist, newinfostatus, newinfodelete, newinforecordlist, newinforecorddetail, newinforetry } from '@/assets/js/common.js'
import pagechange from '../components/pagechange.vue'

const router = useRouter()

// 列表统计
const stats = reactive({
    code_count: 0,
    submit_count: 0,
    added_count: 0,
    pending_count: 0,
    build_fail_count: 0
})

// 列表数据
const tableData = reactive({
    data: []
})
const total = ref(0)

// 搜索条件
const searchdata = reactive({
    page: 1,
    page_size: 20,
    keyword: '',
    status: ''
})

const getlist = () => {
    newinfolist(searchdata).then((response) => {
        if (response.data.msg.code == 0) {
            tableData.data = response.data.data.list
            total.value = response.data.data.total
            Object.assign(stats, response.data.data.stats)
        } else {
            ElMessage({ type: 'warning', message: response.data.msg.info })
        }
    })
}

const changeinput = () => {
    searchdata.page = 1
    getlist()
}
const statuschange = () => {
    searchdata.page = 1
    getlist()
}
const resetsearch = () => {
    searchdata.page = 1
    searchdata.keyword = ''
    searchdata.status = ''
    getlist()
}
const page_change = (val) => {
    searchdata.page = val
    getlist()
}

const goCreate = () => {
    router.push({ path: '/navtkyl/infocollectform' })
}
const goEdit = (id) => {
    router.push({ path: '/navtkyl/infocollectform', query: { id: id } })
}

// 字段展示：前 2 个 + 剩余数量
const fieldText = (row) => {
    const labels = row.field_labels || []
    if (!labels.length) {
        return '—'
    }
    const show = labels.slice(0, 2).join('、')
    return labels.length > 2 ? show + ' +' + (labels.length - 2) : show
}

const expireText = (row) => {
    if (row.is_expired) {
        return '已失效'
    }
    if (!row.expire_at) {
        return ''
    }
    const left = new Date(row.expire_at.replace(/-/g, '/')).getTime() - Date.now()
    if (left <= 0) {
        return '已失效'
    }
    const days = Math.floor(left / 86400000)
    const hours = Math.floor((left % 86400000) / 3600000)
    if (days > 0) {
        return '剩 ' + days + ' 天'
    }
    return hours > 0 ? '剩 ' + hours + ' 小时' : '不足 1 小时'
}

// 启用/停用
const toggleStatus = (row) => {
    const status = row.status === 1 ? 0 : 1
    const text = status === 1 ? '启用' : '停用'
    ElMessageBox.confirm('是否确认' + text + '该收集码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        newinfostatus({ id: row.id, status: status }).then((response) => {
            if (response.data.msg.code == 0) {
                ElMessage({ type: 'success', message: text + '成功！' })
                getlist()
            } else {
                ElMessage({ type: 'warning', message: response.data.msg.info })
            }
        })
    }).catch(() => {})
}

// 删除
const delbtn = (id) => {
    ElMessageBox.confirm('删除后收集码立即失效，已收集的填写记录会保留。是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        newinfodelete({ id: id }).then((response) => {
            if (response.data.msg.code == 0) {
                ElMessage({ type: 'success', message: '删除成功！' })
                getlist()
            } else {
                ElMessage({ type: 'warning', message: response.data.msg.info })
            }
        })
    }).catch(() => {})
}

// 投放链接
const linkWindow = ref(false)
const currentCode = reactive({
    id: 0,
    name: '',
    seat_names: [],
    expire_at: ''
})
const h5Link = ref('')
const openLink = (row) => {
    Object.assign(currentCode, row)
    h5Link.value = window.location.origin + '/h5/info-collect?code=' + row.id
    linkWindow.value = true
}
const openH5 = () => {
    window.open(h5Link.value)
}

const copy = (val) => {
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', val)
    input.select()
    if (document.execCommand('copy')) {
        document.execCommand('copy')
        ElMessage({ message: '复制成功', type: 'success' })
    }
    document.body.removeChild(input)
}

// 填写记录
const recordWindow = ref(false)
const recordData = reactive({
    data: []
})
const recordTotal = ref(0)
const recordStats = reactive({
    submit_count: 0,
    added_count: 0,
    pending_count: 0,
    build_fail_count: 0
})
const recordQuery = reactive({
    code_id: 0,
    page: 1,
    page_size: 20
})
const retryingId = ref(0)

const getRecords = () => {
    newinforecordlist(recordQuery).then((response) => {
        if (response.data.msg.code == 0) {
            recordData.data = response.data.data.list
            recordTotal.value = response.data.data.total
            Object.assign(recordStats, response.data.data.stats)
        } else {
            ElMessage({ type: 'warning', message: response.data.msg.info })
        }
    })
}
const openRecords = (row) => {
    Object.assign(currentCode, row)
    recordQuery.code_id = row.id
    recordQuery.page = 1
    recordWindow.value = true
    getRecords()
}
const recordPageChange = (val) => {
    recordQuery.page = val
    getRecords()
}

// 重试建码
const retry = (id) => {
    retryingId.value = id
    newinforetry({ id: id }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({ type: 'success', message: '已重新生成加人码' })
            getRecords()
            getlist()
        } else {
            ElMessage({ type: 'warning', message: response.data.msg.info })
        }
    }).finally(() => {
        retryingId.value = 0
    })
}

// 填写详情
const detailWindow = ref(false)
const recordDetail = reactive({
    name: '',
    form_data: [],
    seat_name: '',
    created_at: '',
    added_at: '',
    add_status_label: '',
    build_status: 0,
    build_status_label: '',
    fail_reason: ''
})
const openRecordDetail = (id) => {
    newinforecorddetail({ id: id }).then((response) => {
        if (response.data.msg.code == 0) {
            Object.assign(recordDetail, response.data.data)
            detailWindow.value = true
        } else {
            ElMessage({ type: 'warning', message: response.data.msg.info })
        }
    })
}

onMounted(() => {
    getlist()
})
</script>

<style scoped>
.t_stat_box {
    display: flex;
    gap: 10px;
    margin-bottom: 14px;
}

.t_stat {
    flex: 1;
    min-width: 0;
    padding: 12px 14px;
    border: 1px solid #E8ECF3;
    border-radius: 8px;
    background: #FBFCFE;
}

.t_stat_k {
    font-size: 12.5px;
    color: #64748B;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.t_stat_v {
    font-size: 22px;
    font-weight: 700;
    color: #1E293B;
    line-height: 1.3;
    font-variant-numeric: tabular-nums;
}

.t_stat_v em {
    font-size: 12.5px;
    font-weight: 400;
    color: #94A3B8;
    font-style: normal;
    margin-left: 4px;
}

.t_stat--warn .t_stat_v {
    color: #F59E0B;
}

.t_stat--danger .t_stat_v {
    color: #EF4444;
}

.t_sub {
    font-size: 12px;
    color: #94A3B8;
    margin-top: 2px;
}

.t_fail {
    font-size: 12px;
    color: #F56C6C;
    margin-top: 2px;
    word-break: break-all;
}

.t_link_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 12px;
    background: #F1F3F9;
    border-radius: 8px;
    font-size: 13px;
    color: #4F46E5;
    word-break: break-all;
}

.t_detail_row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 7px 0;
    font-size: 13px;
    border-bottom: 1px dashed #E8ECF3;
}

.t_add_people {
    margin-top: 20px;
    margin-bottom: 20px;
}

:deep(.t_search_box .el-input__wrapper) {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}

:deep(.t_search_box .el-select__wrapper) {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>
